<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-layout row wrap >
    <v-flex xs12 sm10 offset-sm1 elevation-8 pt-3 pl-3 pr-3 pb-3 mb-0>
      <v-layout>
        <v-layout pa-1 align-center>
          <span class="headline gray--text s-title hidden-sm-and-down" @click="goHomepage" style="cursor:pointer;">쉽팡 - ShipPang</span>
          <span class="headline gray--text s-title hidden-md-and-up" @click="goHomepage" style="cursor:pointer;">쉽팡<br/>ShipPang</span>
        </v-layout>
        <v-layout class="body-1 gray--text" align-end justify-end pt-2 pb-2 pl-2>

            <v-bottom-sheet inset v-model="openSheet">
              <v-card>

                <v-card-title primary-title>
                  <div>
                    <h3 class="headline mb-0 s-title">쉽팡</h3>
                    <p></p>
                    <p> - 해외직구/통관/국내배송 조회를 한번에!</p>
                    <p> - 배대지/AWB 카고/국내 송장번호를 조회해 보세요</p>
                    <p></p>
                    <h2 class="headline mb-0 s-title">지원 배송사</h2>
                    <p></p>
                    <p> - 관세청(유니패스)</p>
                    <p> - 한진택배</p>
                    <p> - CJ 대한통운</p>
                    <p> - 우체국</p>
                    <p> - 아시아나 카고</p>
<!--                    <p> - 대한항공 카고(서비스 불가)</p>-->
                    <p> - DHL</p>
                    <p> - 알리 익스프레스</p>
                    <p> - FEDEX</p>
                  </div>
                </v-card-title>

              </v-card>
            </v-bottom-sheet>

          <v-btn fab dark small color="blue-grey" @click="shareKakaoLink" style="margin-left: 0px">
            <v-icon dark>mdi-share-variant</v-icon>
          </v-btn>
          <v-btn fab dark small color="blue-grey" @click="openSheet = true" style="margin-left: 0px">
            <v-icon dark>mdi-help</v-icon>
          </v-btn>
          <v-btn fab dark small color="blue-grey" @click="clickOrderDialog" style="margin-left: 0px">
            <v-icon dark>mdi-swap-vertical</v-icon>
          </v-btn>
          <v-btn fab dark small color="blue-grey" @click="openDialog" style="margin-left: 0px">
            <v-icon dark>mdi-menu</v-icon>
          </v-btn>
          <!--<v-btn dark color="blue-grey" class="hidden-sm-and-down">-->
            <!--<v-icon dark>mdi-swap-vertical</v-icon>-->
            <!--ORDER-->
          <!--</v-btn>-->
          <!--<v-btn dark color="blue-grey" class="hidden-sm-and-down">-->
            <!--<v-icon dark>mdi-menu</v-icon>-->
            <!--HISTORY-->
          <!--</v-btn>-->
          <!--<v-icon @click="clickOrderDialog">mdi-swap-vertical</v-icon>-->
          <!--<v-icon-->
            <!--@click="openDialog"-->
            <!--dark-->
            <!--color="primary lighten-1"-->
          <!--&gt;mdi-menu-->
          <!--</v-icon>-->
        </v-layout>
      </v-layout>
        <v-text-field
          style="padding-top:0"
          clearable
          type="text"
          v-model="no"
          ref="no"
          maxlength="20"
          @input="changeInput"
          @keyup.enter="onEnter"
          @keyup="onKeyUp"
          @change="onKeyUp"
          @paste="onPaste"
          hint="송장번호를 입력하세요. (CJ대한통운/우체국/한진/카고)"
          persistent-hint
        >
            <v-progress-circular
              v-if="loading"
              size="24"
              color="info"
              indeterminate
              slot="append"
            ></v-progress-circular>
            <v-icon
              class="hidden-md-and-up"
              slot="append"
              @click="searchTerm"
              dark
              color="red lighten-1"
            >search</v-icon>

            <v-btn
              class="hidden-sm-and-down"
              @click="searchTerm"
              style="top: -12px; margin-right:15px;"
              offset-y
              slot="append-outer"
              dark
              color="red lighten-1"
            >
              <span class="white--text">Search</span>
            </v-btn>
        </v-text-field>
      <v-alert
        :value="isInfo"
        type="info"
      >
        {{ infoMessage }}
      </v-alert>
        <v-alert
          :value="isError"
          type="error"
        >
          {{ alertMessage }}
        </v-alert>
    </v-flex>

    <!--광고 영역-->
    <v-container fill-height fluid>
      <v-layout column>

        <v-flex xs12>
          <!-- 반응형 -->
          <!--<ins class="adsbygoogle"-->
               <!--style="display:block; min-width:250px; max-height:300px;"-->
               <!--data-ad-client="ca-pub-4697305889011107"-->
               <!--data-ad-slot="3718580278"-->
               <!--data-ad-format="auto"-->
               <!--data-full-width-responsive="true"></ins>-->

          <ins class="adsbygoogle"
              style="display:block; min-width:250px; max-height:250px;"
               data-ad-client="ca-pub-4057921282786438"
               data-ad-slot="8835473571"
               data-ad-format="auto"></ins>
        </v-flex>
      </v-layout>
    </v-container>

    <!-- 메인 -->
    <v-flex>

      <v-flex v-for="(item) in viewOrder" :key="item.code" mt-3>
        <component v-if="getModel(item.code) !== null" :model="getModel(item.code)" :is="getComponent(item.code)" ></component>
      </v-flex>
    </v-flex>
    <v-snackbar
      v-model="snackbar"
      dark
      vertical
      auto-height
      :timeout="4000"
      top
      style="white-space: pre-line;"
    >
      {{ this.snackbarMessage }}
      <div>
      <v-btn
        small
        round
        color="primary"
        @click="goGooglePlay"
        style="font-size: small; padding: 1px 10px 0px 10px;"
        v-show="isAndroid"
      >
        앱 설치
      </v-btn>
      <v-btn
        flat
        small
        color="error"
        @click="closeSnackbar"
        style="float:right;"
      >
        일주일간 보지않기
      </v-btn>
      </div>
    </v-snackbar>
    <div >
      <v-dialog v-model="orderDialog" width="80%" @input="v => v || closeOrderDialog()">
        <v-layout column>
          <v-list style="padding-top:0; padding-bottom: 0;">
            <template v-for="(item, index) in viewOrder">
              <v-list-tile
                :key="index"
                @click="{}"
              >
              <!--<v-list-tile-->
                <!--:style="`background: ${item.color}`"-->
                <!--:key="index"-->
                <!--@click="{}"-->
              <!--&gt;-->
                <v-list-tile-content
                >
                  <v-list-tile-title v-html="item.name"></v-list-tile-title>
                  <!--<v-list-tile-sub-title v-html="item.name"></v-list-tile-sub-title>-->
                </v-list-tile-content>
                <v-list-tile-action v-if="index +1 < viewOrder.length">
                  <v-btn icon ripple @click="clickOrder(index, false)">
                    <v-icon >mdi-chevron-double-down</v-icon>
                  </v-btn>
                </v-list-tile-action>
                <v-list-tile-action v-else >
                  <v-btn disabled icon ripple>
                    <v-icon >mdi-chevron-double-down</v-icon>
                  </v-btn>
                </v-list-tile-action>

                <v-list-tile-action v-if="index !== 0">
                  <v-btn icon ripple @click="clickOrder(index, true)">
                    <v-icon >mdi-chevron-double-up</v-icon>
                  </v-btn>
                </v-list-tile-action>
                <v-list-tile-action v-else >
                  <v-btn disabled icon ripple>
                    <v-icon >mdi-chevron-double-up</v-icon>
                  </v-btn>
                </v-list-tile-action>

              </v-list-tile>
              <v-divider v-if="index + 1 < viewOrder.length" :key="`divider-${index}`"></v-divider>
            </template>
          </v-list>
        </v-layout>
      </v-dialog>
    </div>
    <div >
      <v-dialog v-model="dialog2" width="90%" @input="v => v || closeDialog()">
        <!--<v-dialog v-model="dialog2" width="80%" style="overflow:auto;-webkit-overflow-scrolling:touch">-->
        <v-flex v-if="this.deliveryNumbers.length <= 0" style="background-color: white" pa-4  text-xs-center>
            <span class="subheading">
              검색한 이력이 없습니다
            </span>

        </v-flex>
        <v-layout v-else column>
          <v-list two-line>
            <template v-for="(item, index) in deliveryNumbers">
              <v-list-tile
                :key="index"
                avatar
                @click="{}"
              >
                <v-list-tile-content
                  @click="clickDeliveryNumberPopup(item)"
                >
                  <v-list-tile-title v-html="item.deliveryNumber"></v-list-tile-title>
                  <v-list-tile-sub-title v-html="item.description"></v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-btn icon ripple @click="removeDeliveryNumber(item)">
                    <v-icon color="grey lighten-1">mdi-minus-circle</v-icon>
                  </v-btn>
                </v-list-tile-action>
              </v-list-tile>
              <v-divider v-if="index + 1 < deliveryNumbers.length" :key="`divider-${index}`"></v-divider>
            </template>
          </v-list>
          <!--<v-btn @click="closeDialog">-->
            <!--CLOSE-->
          <!--</v-btn>-->
          <!--<template v-for="(item, index) in deliveryNumbers">-->
          <!--<v-flex :key="index" pa-4>-->
          <!--<v-card>-->
          <!--<span class="subheading">{{ item }}</span>-->
          <!--</v-card>-->
          <!--</v-flex>-->
          <!--</template>-->
        </v-layout>
      </v-dialog>
    </div>
  </v-layout>
</template>

<script>
import DoorToDoorDeliveryCard from '@/components/card/DoorToDoorDeliveryCard'
import AbroadDeliveryCard from './card/AbroadDeliveryCard'
import EPostDeliveryCard from './card/EPostDeliveryCard'
import AsianaCargoCard from './card/AsianaCargoCard'
import HanjinDeliveryCard from './card/HanjinDeliveryCard'
import KoreanAirCargoCard from './card/KoreanAirCargoCard'
import Track17Card from './card/Track17Card'
import CainiaoCard from './card/CainiaoCard'
import DhlCard from './card/DhlCard'
import FedexCard from './card/FedexCard'
import Vue from 'vue'
import EventBus from '../common/EventBus'
import EmsCard from './card/EmsCard'
import LotteGlobalLogisCard from './card/LotteGlobalLogisCard'

export default {
  name: 'DeliveryInfo',
  components: {DoorToDoorDeliveryCard, AbroadDeliveryCard, EmsCard, EPostDeliveryCard, AsianaCargoCard, HanjinDeliveryCard, Track17Card, CainiaoCard, DhlCard, FedexCard, LotteGlobalLogisCard},
  data: function () {
    return {
      alertMessage: '',
      isError: false,
      infoMessage: '',
      isInfo: false,
      loading: false,
      unipass: null,
      doorToDoor: null,
      epost: null,
      ems: null,
      asianaCargo: null,
      hanjin: null,
      lotte: null,
      dhl: null,
      fedex: null,
      // no: '433936903703'
      no: null,
      deliveryNumbers: [],
      dialog2: false,
      orderDialog: false,
      snackbar: false,
      snackbarMessage: null,
      test: DoorToDoorDeliveryCard,
      viewOrder: [],
      openSheet: false,
      debug: false,
      isAndroid: false
    }
  },
  computed: {
  },
  methods: {
    goHomepage () {
      window.open('http://shippang.com', '_blank')
    },
    getModel (code) {
      switch (code) {
        case 'doorToDoor':
          return this.doorToDoor
        case 'ems':
          return this.ems
        case 'epost':
          return this.epost
        case 'hanjin':
          return this.hanjin
        case 'lotte':
          return this.lotte
        case 'unipass':
          return this.unipass
        case 'asianaCargo':
          return this.asianaCargo
        case 'koreanAirCargo':
          return this.koreanAirCargo
        case 'track17':
          return this.track17
        case 'cainiao':
          return this.cainiao
        case 'dhl':
          return this.dhl
        case 'fedex':
          return this.fedex
      }
    },
    getComponent (code) {
      switch (code) {
        case 'doorToDoor':
          return DoorToDoorDeliveryCard
        case 'ems':
          return EmsCard
        case 'epost':
          return EPostDeliveryCard
        case 'hanjin':
          return HanjinDeliveryCard
        case 'lotte':
          return LotteGlobalLogisCard
        case 'unipass':
          return AbroadDeliveryCard
        case 'asianaCargo':
          return AsianaCargoCard
        case 'koreanAirCargo':
          return KoreanAirCargoCard
        case 'track17':
          return Track17Card
        case 'cainiao':
          return CainiaoCard
        case 'dhl':
          return DhlCard
        case 'fedex':
          return FedexCard
      }
    },
    clickOrder (index, goingUp) {
      if (goingUp === true) {
        const tmp = this.viewOrder[index]
        Vue.set(this.viewOrder, index, this.viewOrder[index - 1])
        Vue.set(this.viewOrder, index - 1, tmp)
      } else {
        const tmp = this.viewOrder[index]
        Vue.set(this.viewOrder, index, this.viewOrder[index + 1])
        Vue.set(this.viewOrder, index + 1, tmp)
      }
      this.$cookie.set('viewOrder', JSON.stringify(this.viewOrder), { expires: '1Y' })
    },
    clickOrderDialog () {
      this.orderDialog = true
    },
    copyClipboard: function (val) {
      var first = document.body.children[0]
      var t = document.createElement('input')
      document.body.insertBefore(t, first)
      // document.body.appendChild(t)
      t.value = val
      t.select()
      document.execCommand('copy')
      document.body.removeChild(t)
    },
    clickHelp: function () {
    },
    clickCopy: function () {
      if (this.no === null || this.no === '') {
        this.copyClipboard(document.location.origin)
      } else {
        this.copyClipboard(document.location.origin + '?no=' + this.no)
      }
      this.snackbar = true
    },
    closeOrderDialog: function () {
      if (this.no !== null && this.no !== '') {
        this.searchTerm()
      }
      this.orderDialog = false
    },
    closeDialog: function () {
      this.dialog2 = false
    },
    openDialog: function () {
      this.dialog2 = true
    },
    clickDeliveryNumberPopup: function (node) {
      this.no = node.deliveryNumber
      this.closeDialog()
      this.searchTerm()
    },
    removeDeliveryNumber: function (node) {
      this.deliveryNumbers = this.deliveryNumbers.filter((it) => {
        return it.deliveryNumber !== node.deliveryNumber
      })
      this.$cookie.set('deliveryNumbers', JSON.stringify(this.deliveryNumbers), '1Y')
    },
    onKeyUp: function () {
      // const removeNumber = this.no.replace(/\D/g, '')
      let removeNumber = this.no.replace(/[^a-zA-Z0-9]+/g, '')
      if (removeNumber.startsWith('Web')) {
        removeNumber = removeNumber.substring(3)
      }
      this.no = removeNumber
    },
    onPaste: function (evt) {
      let removeNumber = (evt.clipboardData || window.clipboardData).getData('text')
      removeNumber = removeNumber.replace(/[^a-zA-Z0-9]+/g, '')
      if (removeNumber.startsWith('Web')) {
        removeNumber = removeNumber.substring(3)
      }
      this.no = removeNumber
      evt.preventDefault()
    },
    onEnter: function () {
      this.searchTerm()
    },
    searchTermValid: function () {
      if (this.no === null || this.no === '') {
        return
      }
      this.search()
    },
    search: function () {
      let item = this.deliveryNumbers.find(item => item.deliveryNumber === this.no)
      if (item === undefined) {
        this.deliveryNumbers.push({deliveryNumber: this.no, description: ''})
      }

      this.init()
      this.loading = true

      this.$refs.no.blur()

      this.$http.get(`/${this.no}`)
        .then((result) => {
          // console.log(result)
          this.doorToDoor = result.data.doorToDoor
          this.unipass = result.data.unipass
          this.epost = result.data.epost
          this.ems = result.data.ems
          this.asianaCargo = result.data.asianaCargo
          this.hanjin = result.data.hanjin
          this.lotte = result.data.lotte
          this.koreanAirCargo = result.data.koreanAirCargo
          this.track17 = result.data.track17
          this.cainiao = result.data.cainiao
          this.dhl = result.data.dhl
          this.fedex = result.data.fedex

          if (this.doorToDoor && this.doorToDoor.baseInfo && this.doorToDoor.baseInfo.productName) {
            // 팝업 목록에 CJ 상품명 추가
            let item = this.deliveryNumbers.find(item => item.deliveryNumber === this.no)
            item.description = 'CJ-' + this.doorToDoor.baseInfo.productName
          } else if (this.hanjin && this.hanjin.baseInfo && this.hanjin.baseInfo.productName) {
            // 팜업 목록에 한진 상품명 추가
            let item = this.deliveryNumbers.find(item => item.deliveryNumber === this.no)
            item.description = '한진-' + this.hanjin.baseInfo.productName
          } else if (this.unipass && this.unipass.baseInfo && this.unipass.baseInfo.prnm) {
            // 팝업 목록에 관세청 상품명 추가
            let item = this.deliveryNumbers.find(item => item.deliveryNumber === this.no)
            item.description = this.unipass.baseInfo.prnm
          } else if (this.track17 && this.track17.baseInfo && this.track17.baseInfo.lastStatus) {
            // 팝업 목록에 알리 진행상황 표시
            // let item = this.deliveryNumbers.find(item => item.deliveryNumber === this.no)
            // item.description = this.track17.baseInfo.lastStatus
          }
          if (this.cainiao && this.cainiao.baseInfo && this.cainiao.baseInfo.statusDesc) {
            // 팝업 목록에 알리 진행상황 표시
            let item = this.deliveryNumbers.find(item => item.deliveryNumber === this.no)
            item.description = 'China-' + this.cainiao.baseInfo.statusDesc
          }
          if (this.ems && this.ems.baseInfo && this.ems.baseInfo.lastStep) {
            // 팝업 목록에 우체국 최종 상태 추가
            let item = this.deliveryNumbers.find(item => item.deliveryNumber === this.no)
            item.description = '우체국-' + this.ems.baseInfo.lastStep
          }
          if (this.epost && this.epost.baseInfo && this.epost.baseInfo.lastStep) {
            // 팝업 목록에 우체국 최종 상태 추가
            let item = this.deliveryNumbers.find(item => item.deliveryNumber === this.no)
            item.description = '우체국-' + this.epost.baseInfo.lastStep
          }
          if (this.dhl && this.dhl.baseInfo && this.dhl.baseInfo.lastDetailKind) {
            // 팝업 목록에 DHL 최종 상태 추가
            let item = this.deliveryNumbers.find(item => item.deliveryNumber === this.no)
            item.description = 'DHL-' + this.dhl.baseInfo.lastDetailKind
          }
          if (this.lotte && this.lotte.baseInfo && this.lotte.baseInfo.destination) {
            // 팝업 목록에 우체국 최종 상태 추가
            let item = this.deliveryNumbers.find(item => item.deliveryNumber === this.no)
            item.description = '롯데-' + this.lotte.baseInfo.destination
          }

          this.$refs.no.blur()

          // 결과없음
          if (this.doorToDoor == null &&
            this.unipass == null &&
            this.ems == null &&
            this.epost == null &&
            this.asianaCargo == null &&
            this.hanjin == null &&
            this.lotte == null &&
            this.koreanAirCargo == null &&
            this.track17 == null &&
            this.cainiao == null &&
            this.dhl == null &&
            this.fedex == null
          ) {
            this.isInfo = true
            this.infoMessage = '검색 결과가 존재하지 않습니다.'
          }
        })
        .catch((error) => {
          console.log(error)
          this.isError = true
          try {
            if (error.message.indexOf('timeout') >= 0 || error.message.indexOf('Network') >= 0) {
              this.alertMessage = '네트워크 오류가 발생하였습니다.  다시 시도해 주세요.'
            } else if (error.response.data.message != null) {
              this.alertMessage = error.response.data.message
            } else {
              this.alertMessage = '오류가 발생하였습니다.  잠시 후 다시 시도해 주세요.'
            }
          } catch (e) {
            this.alertMessage = '오류가 발생하였습니다.  잠시 후 다시 시도해 주세요.'
          }
        })
        .finally((_) => {
          this.$cookie.set('deliveryNo', this.no, { expires: '1Y' })
          this.$cookie.set('deliveryNumbers', JSON.stringify(this.deliveryNumbers), { expires: '1Y' })
          this.loading = false
        })
    },
    searchTerm: function () {
      if (this.no === null || this.no === '') {
        this.isInfo = false
        this.isError = true
        this.alertMessage = '값을 입력 해 주세요'
        this.$refs.no.focus()
        return
      }

      this.search()
    },
    changeInput: function () {
      if (this.no == null) {
        this.$cookie.delete('deliveryNo')
        this.init()
      }
    },
    init: function () {
      this.doorToDoor = null
      this.unipass = null
      this.ems = null
      this.epost = null
      this.asianaCargo = null
      this.hanjin = null
      this.lotte = null
      this.koreanAirCargo = null
      this.track17 = null
      this.cainiao = null
      this.dhl = null
      this.fedex = null
      this.isError = false
      this.isInfo = false
    },
    closeSnackbar () {
      this.$cookie.set('notice', 'N', { expires: 7 })
      // this.$cookie.set('notice', 'N', { expires: '30s' })
      this.snackbar = false
    },
    openSnackbar (message) {
      this.snackbarMessage = message
      this.snackbar = true
    },
    initKakaoLink: function () {
      window.Kakao.init('911c4a750b9ac0800a6b184b6c6d6a8a')
    },
    shareKakaoLink () {
      // const mainDomain = 'http://shippang.com'
      const deliveryDomain = 'http://delivery.donnert.net'
      window.Kakao.Link.sendDefault({
        objectType: 'feed',
        installTalk: true,
        content: {
          title: '쉽팡',
          description: '배송 진행 상황을 공유합니다.  버튼을 눌러 확인해 보세요',
          imageUrl: 'http://shippang.com/img/favicon.png',
          link: {
            androidExecParams: 'no=' + this.no,
            iosExecParams: 'no=' + this.no,
            mobileWebUrl: deliveryDomain + '?no=' + this.no,
            webUrl: deliveryDomain + '?no=' + this.no
          }
        },
        // social: {
        //   likeCount: 286,
        //   commentCount: 45,
        //   sharedCount: 845
        // },
        buttons: [
          {
            title: '웹으로 보기',
            link: {
              mobileWebUrl: deliveryDomain + '?no=' + this.no,
              webUrl: deliveryDomain + '?no=' + this.no
            }
          },
          {
            title: '앱(안드로이드)',
            link: {
              androidExecParams: 'no=' + this.no,
              mobileWebUrl: deliveryDomain + '?no=' + this.no,
              webUrl: deliveryDomain + '?no=' + this.no
            }
          }
        ]
      })
    },
    goGooglePlay () {
      location.href = 'https://play.google.com/store/apps/details?id=com.shippang.shippang&hl=ko'
    }
  },
  mounted () {
    EventBus.$on('goSearch', this.searchTermValid)
    EventBus.$on('clickDeliveryNumberPopup', this.clickDeliveryNumberPopup)
    EventBus.$on('removeDeliveryNumber', this.removeDeliveryNumber)
    this.initKakaoLink()
    const defaultViewOrder = [
      {
        code: 'doorToDoor',
        name: 'CJ 대한통운',
        color: '#EFEBE9'
      }, {
        code: 'hanjin',
        name: '한진',
        color: '#E0F2F1'
      }, {
        code: 'lotte',
        name: '롯데',
        color: '#E0F2F1'
      }, {
        code: 'ems',
        name: '우체국(EMS)',
        color: '#FDF0F0'
      }, {
        code: 'epost',
        name: '우체국',
        color: '#FDF0F0'
      }, {
        code: 'unipass',
        name: '관세청',
        color: '#ECEFF1'
      }, {
        code: 'asianaCargo',
        name: '아시아나 카고',
        color: '#EDE7F6'
      }, {
        code: 'koreanAirCargo',
        name: '대한항공 카고',
        color: '#E0F2F1'
      }, {
        code: 'cainiao',
        name: 'China',
        color: '#E0F2F1'
      }, {
        code: 'dhl',
        name: 'DHL',
        color: '#E0F2F1'
      }, {
        code: 'fedex',
        name: 'FEDEX',
        color: '#E0F2F1'
      }
    ]
    try {
      this.viewOrder = (this.$cookie.get('viewOrder') === null) ? defaultViewOrder : JSON.parse(this.$cookie.get('viewOrder'))
    } catch (_) {
      this.viewOrder = defaultViewOrder
    }

    if (this.viewOrder.length !== 11) {
      this.viewOrder = defaultViewOrder
    }
    this.$cookie.set('viewOrder', JSON.stringify(this.viewOrder), { expires: '1Y' })

    const isDebug = this.$route.query.debug
    if (isDebug !== undefined && isDebug !== null && isDebug !== '') {
      this.debug = (isDebug === 'true')
    }

    const noFromQuery = this.$route.query.no
    if (noFromQuery !== undefined && noFromQuery !== null && noFromQuery !== '') {
      this.no = noFromQuery
    } else {
      this.no = this.$cookie.get('deliveryNo')
    }
    this.deliveryNumbers = this.$cookie.get('deliveryNumbers') === null ? [] : JSON.parse(this.$cookie.get('deliveryNumbers')).reverse()
    if (this.no !== null && this.no !== '') {
      this.searchTerm()
    }

    // 공지
    // console.log('snack!')
    // this.snackbar = true
    // let noticeMessage = '카카오톡 공유 기능 추가\n배송 진행 상황을 공유하세요'
    // let noticeMessage = '해상 조회 기능이 추가되었습니다.\n(MarineTraffic, MyShipTracking)'
    // let noticeMessage = 'DHL 조회 기능이 추가되었습니다.'
    // let noticeMessage = 'FEDEX 조회 기능이 추가되었습니다.'
    // let noticeMessage = '한진 조회 기능이 일시적으로 중지되었습니다.'
    // let noticeMessage = '관세청 조회 기능이 정상화되었습니다.'
    // let noticeMessage = '한진 조회 기능이 정상화되었습니다.'
    // let noticeMessage = '오류,요청사항은 메일로 연락해 주세요.\n(shippang.com@gmail.com)'
    let noticeMessage = '오류,요청사항은 메일로 연락해 주세요.\n(admin@shippang.com)'
    // let noticeMessage = '쉽팡 앱으로 이용하세요'
    const userAgent = navigator.userAgent.toLowerCase()
    if (userAgent.indexOf('android') > -1) {
      this.isAndroid = true
    }

    if (this.$cookie.get('notice') !== 'N') {
      setTimeout(() => {
        this.openSnackbar(noticeMessage)
      }, 1400)
    }
  },
  destroyed () {
    EventBus.$off('goSearch', this.searchTermValid)
    EventBus.$off('clickDeliveryNumberPopup', this.clickDeliveryNumberPopup)
    EventBus.$off('removeDeliveryNumber', this.removeDeliveryNumber)
  }
}
</script>

<style>
  .s-title {
    font-family: 'Jua', sans-serif !important;
  }
  .v-snack__content {
    padding-top: 0 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/DeliveryInfo.vue